// extracted by mini-css-extract-plugin
module.exports = {"grid":"Rules_grid__Z6jbj","fw":"Rules_fw__GCqEo","fwMob":"Rules_fwMob__sJR_1"};